import React from 'react'
import { IProps } from './index'
import { Hero } from '../../../../library/elements/Hero'
import { Details } from '../../../../library/elements/Details'
import { LearnLinks } from '../links'
import { mq } from 'marketing-site/src/library/utils'

export const Demo = (props: IProps): React.ReactElement => {
  return (
    <>
      <Hero {...props} />
      <Details {...props} />
      <LearnLinks {...props.related} />

      <style jsx global>
        {`
          @media (${mq.tablet}) {
            .learn-links__wrap {
              padding-top: 7.5rem;
            }

            .learn-links__grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
        `}
      </style>
    </>
  )
}
